/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Reason_Sea_TextInputs */



/**
* | output |
* | --- |
* | "Our Master Mariners and Chief Engineers bring decades of sea-going experience to every job." |
*
* @param {Home_Reason_Sea_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_reason_sea_text = /** @type {((inputs?: Home_Reason_Sea_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Reason_Sea_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("我们的船长和轮机长将数十年的航海经验带到每一项工作中。")
	return /** @type {LocalizedString} */ ("Our Master Mariners and Chief Engineers bring decades of sea-going experience to every job.")
});